import { Component, OnInit, Inject } from "@angular/core";
import { Addendum } from "../models/addendum";
import { AddendumService } from "../services/addendum.service";
import { ActivatedRoute, Router } from "@angular/router";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { UserRoleEnum, AddendumStatusEnum, Constant } from "../core/constant";
import { Standard } from "../models/standard";
import { StandardService } from "../services/standard.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { AddendumAttachment } from "../models/addendum-attachment";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CryptographyService } from "../services/cryptography.service";
import { SelectedStandard } from "../models/selected-standard";
import { SelectedEquipmentStandard } from "../models/selected-equipment-standard";
import { EquipmentAddendum } from "../models/equipment-addendum";
import { EquipmentStandard } from "../models/equipment-standard";
import { EquipmentStandardService } from "../services/equipment -standard.service";

@Component({
  selector: "app-add-equipment-addendum",
  templateUrl: "./add-equipment-addendum.component.html",
  styleUrls: ["./add-equipment-addendum.component.scss"],
})
export class AddEquipmentAddendumComponent implements OnInit {
  loading: boolean = false;
  addendumForm: FormGroup;
  userRole: number = 2;
  addendum: EquipmentAddendum = new EquipmentAddendum();
  error: string = "";
  invalidFile: boolean = false;
  invalidFileMessage: string = "";
  get addendumStatusEnum() {
    return AddendumStatusEnum;
  }
  get userRoleEnum() {
    return UserRoleEnum;
  }

  constructor(
    private addendumService: AddendumService,
    private standardService: StandardService,
    private equipmentStandardService: EquipmentStandardService,
    private cryptographyService: CryptographyService,
    private router: Router,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService,
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder,
    private ngbModal: NgbModal
  ) {
    this.addendum.standardId = parseInt(
      this.activeRoute.snapshot.paramMap.get("standardId")
    );
  }

  ngOnInit() {
    this.loading = true;
    this.userRole = this.cryptographyService.decryptData(
      this.storage.get("userRole")
    );
    this.addendum.createdUserId = this.cryptographyService.decryptData(
      this.storage.get("userId")
    );
    this.createForm();
    this.getDraftAddendumIfExist(
      this.addendum.standardId,
      this.cryptographyService.decryptData(this.storage.get("countryId"))
    ).subscribe((addendumObj) => {
      if (addendumObj.id) {
        this.addendum = addendumObj;
        this.addendumForm.controls.description.setValue(
          this.addendum.description
        );
        this.addendumForm.controls.note.setValue(this.addendum.note);
      } else {
        this.getNewAddendumDetails(this.addendum.standardId);
      }
      this.loading = false;
    });

    this.getNewAddendumDetails(this.addendum.standardId);
  }

  getNewAddendumDetails(standardId: number): void {
    this.loading = true;
    this.equipmentStandardService
      .getEquipmentStandardByStandardId(standardId)
      .subscribe((data: EquipmentStandard) => {
        var t = new Addendum();
        t.standard = new Standard();
        this.addendum = new EquipmentAddendum();
        this.addendum.equipmentStandard = new EquipmentStandard(data);
        this.addendum.standardId = this.addendum.equipmentStandard.standardId;
        (error: string) => {
          this.loading = false;
          this.error = error;
        };
      });
  }

  getDraftAddendumIfExist(
    standardId: number,
    countryId: Array<number>
  ): Observable<any> {
    return new Observable<any>((observer) => {
      this.addendumService
        .getDraftBeforeRequestAddendumInformationByStandardIdAndCountryId(
          standardId,
          countryId
        )
        .subscribe((data: EquipmentAddendum) => {
          observer.next(new EquipmentAddendum(data));
        });
    });
  }

  createForm(): void {
    this.addendumForm = this.fb.group({
      description: ["", Validators.required],
      note: ["", Validators.required],
    });
  }

  submitTheAddendum() {
    if (this.addendumForm.valid) {
      this.addendum.description = this.addendumForm.controls.description.value;
      this.addendum.note = this.addendumForm.controls.note.value;
      this.addendum.countryId = this.cryptographyService.decryptData(
        this.storage.get("countryId")
      );
      this.addendum.addendumStatusId = this.addendumStatusEnum.Requested;
      this.addendum.createdUserId = this.cryptographyService.decryptData(
        this.storage.get("userId")
      );
      this.saveAddendum(this.addendum);
    }
  }

  saveAsADraft() {
    if (this.addendumForm.valid) {
      this.addendum.description = this.addendumForm.controls.description.value;
      this.addendum.note = this.addendumForm.controls.note.value;
      this.addendum.countryId = this.cryptographyService.decryptData(
        this.storage.get("countryId")
      );
      this.addendum.addendumStatusId =
        this.addendumStatusEnum.DraftBeforeRequest;
      this.addendum.createdUserId = this.cryptographyService.decryptData(
        this.storage.get("userId")
      );
      this.saveAddendum(this.addendum);
    }
  }

  onSelectAAddendumDocument(event) {
    this.invalidFileMessage = "";
    let selectedFile = event.target.files[0];
    this.invalidFile =
      this.validateFileType(selectedFile.name) ||
      this.validateFileSize(selectedFile);
    this.convertToBaseString(selectedFile).subscribe((result) => {
      this.addendum.addendumAttachment = [];
      this.addendum.addendumAttachment.push(new AddendumAttachment());
      this.addendum.addendumAttachment[0].fileName = selectedFile.name;
      this.addendum.addendumAttachment[0].addendumId = this.addendum.id;
      this.addendum.addendumAttachment[0].isRequestedFile = true;
      this.addendum.addendumAttachment[0].attachmentContentAsBase64 = result;
      event.target.value = null;
    });
  }

  convertToBaseString(selectedFile): Observable<any> {
    return new Observable<any>((observer) => {
      var fileReader = new FileReader();
      if (fileReader && selectedFile) {
        fileReader.readAsDataURL(selectedFile);
        fileReader.onload = function () {
          observer.next(fileReader.result.toString());
        };
      }
    });
  }

  onRemoveAddendumDocument() {
    this.addendum.addendumAttachment = [];
    this.invalidFile = false;
  }

  private saveAddendum(addendum) {
    this.loading = true;
    if (addendum.id) {
      this.addendumService.updateAddendum(addendum).subscribe((result) => {
        this.loading = false;
        this.router.navigate(["/equipment-addendum-list"]);
        (error: string) => {
          this.loading = false;
          this.error = error;
        };
      });
    } else {
      this.addendumService
        .addEquipmentAddendum(addendum)
        .subscribe((result) => {
          if (result == false) {
            this.loading = false;
            const modalRef = this.ngbModal.open(SuccessDialogComponent);
            modalRef.componentInstance.title = "Error";
            modalRef.componentInstance.message =
              "Addendum already added for the standard.";

            modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
              this.ngbModal.dismissAll();
              this.router.navigate([
                "/view-all-national-equipment-standard-list",
              ]);
            });
          } else {
            this.loading = false;
            this.router.navigate([
              "/view-all-national-equipment-standard-list",
            ]);
            (error: string) => {
              this.loading = false;
              this.error = error;
            };
          }
        });
    }
  }

  onDownloadSelectedAddendumDocument() {
    fetch(
      this.addendum.addendumAttachment[0].attachmentContent
        ? this.addendum.addendumAttachment[0].mime +
            this.addendum.addendumAttachment[0].attachmentContent
        : this.addendum.addendumAttachment[0].attachmentContentAsBase64
    )
      .then((res) => res.blob())
      .then((blob) => {
        if ((window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveBlob(
            blob,
            this.addendum.addendumAttachment[0].fileName
          );
        } else {
          var a = document.createElement("a");
          a.href = this.addendum.addendumAttachment[0].attachmentContent
            ? this.addendum.addendumAttachment[0].mime +
              this.addendum.addendumAttachment[0].attachmentContent
            : this.addendum.addendumAttachment[0].attachmentContentAsBase64;
          a.setAttribute(
            "download",
            this.addendum.addendumAttachment[0].fileName
          );
          a.click();
        }
      });
  }

  validateFileType(fileName: string) {
    let fileTypeArr = ["docx", "doc"];
    if (fileName != null) {
      let fileNameArr = [];
      let splitedFileName = fileName.toLowerCase().split(".");
      splitedFileName.forEach(function (obj) {
        fileNameArr.push(obj);
      });
      fileNameArr = fileNameArr.reverse();
      if (!fileTypeArr.includes(fileNameArr[0])) {
        this.invalidFileMessage = "Invalid file type.";
        return true;
      }
    }
  }

  validateFileSize(file: any) {
    if (file.size > 10485760) {
      this.invalidFileMessage = "File size exceeds maximum limit 10 MB.";
      return true;
    }
  }
}
